import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import QRScanner from "src/shared/components/qr-scanner";

interface IProps {
  open: boolean;
  handleClose: () => void;
  onSave: (value: string) => void;
}

function getLastPathPart(value: string): string {
  if (!value) return value;

  const parts = value.split("/").filter(Boolean);
  return parts[parts.length - 1] ?? value;
}

export default function ScanPopup(props: Readonly<IProps>) {
  const { open, handleClose, onSave } = props;

  const getCode = (code: any) => {
    console.log("get code", { code });
    if (code?.data) {
      const ticketId = getLastPathPart(code?.data);
      onSave(ticketId);
      handleClose();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Scan Ticket</DialogTitle>
      <DialogContent sx={{ minWidth: { xs: "100%", sm: "500px" } }}>
        <QRScanner getCode={getCode} />
      </DialogContent>
      <DialogActions
        sx={{
          p: "0 22px 22px 22px",
          gap: 1,
        }}
      >
        <Button onClick={handleClose} color="inherit" sx={{ minWidth: "81px" }}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
